import DeviceCheck from '@/assets/DeviceCheck.js'
import axios from 'axios'

export default {
  setPageTitle: function(string) {
    document.title = string+' - Odense Rundt';
    document.getElementById('mobile-page-title-text').innerHTML = string;
  },

  sortArrayByString: function(array, string) {
    array.sort(function(a, b) {
      var aProperty = a[string].toLowerCase().replace(/æ/gi, 'zz')
                      .replace(/ø/gi, 'zzz')
                      .replace(/å/gi, 'zzzz')
                      .replace(/ /g, '');

      var bProperty = b[string].toLowerCase().replace(/æ/gi, 'zz')
                      .replace(/ø/gi, 'zzz')
                      .replace(/å/gi, 'zzzz')
                      .replace(/ /g, '');
      return ((aProperty < bProperty) ? -1 : ((aProperty > bProperty) ? 1 : 0));
    });
  },

  sortArrayByInt: function(array, int) {
    array.sort(function(a, b) {
			var aInt = a[int];
			var bInt = b[int];
			return ((aInt < bInt) ? -1 : ((aInt > bInt) ? 1 : 0));
		});
  },

  checkForLiveData: function(data) {
    return new Promise((resolve) => {
      var liveDataPropFound = false;
      for(var i = 0; i < data.length; i++) {
        for(var k in data[i].properties) {
          if(data[i].properties[k].id == 78) {
            liveDataPropFound = true;
          }
        }
      }
      resolve(liveDataPropFound);
    });
  },

  //Check if expired
  checkExpireDate: function(item) {
  	if(item.endDate) {
  		if(item.endDate != false) {
  			var d = new Date();
  			var time = d.getTime();
  			//console.log(item);
  			if(item.endDate > time/1000) {
  				return true;
  			}
  			else {
  				return false;
  				/*console.log('expired');
  				console.log('now', time/1000);
  				console.log('endDate', item.endDate);*/
  			}
  		}
  	}
  	else {
  		return true;
  	}
  },

  hasProp: function(number, data) {
  	return (data.properties["prop"+number] != undefined);
  },

  resetCoords: function(coords) {
    return (coords[0] > coords[1]) ? coords.reverse() : coords;
  },

  findFirstCoords: function(obj) {
  	if(obj.geometry) {
  		if(obj.geometry.type == 'Point') {
  			return obj.geometry.coordinates;
  		}
  		else if(obj.geometry.type == 'LineString') {
  			return obj.geometry.coordinates[0];
  		}
  		else if(obj.geometry.type == 'Polygon') {
  			return obj.geometry.coordinates[0][0];
  		}
  	}
  	return false;
  },

  checkForHighestResolution: function(imgName) {
    return new Promise((resolve) => {
      var img = imgName.split('/');
      const params = new URLSearchParams();
      params.append('img', img[img.length-1]);
      params.append('mobile', DeviceCheck.isMobile);

      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/media/images/biggestimage.php/',
        data: params
      }).then((response) => {
        //console.log(response.data);
        resolve(response.data);
      });
    });
  },

  trackSession: function(site, value) {
    if(localStorage.getItem('OdenseRundt-StatisticsCookies') == 'true') {
      var date = new Date();
    	var dateObject = date.getFullYear()+','+date.getMonth()+','+date.getDate();
  		var savedData = JSON.parse(localStorage.getItem('OdenseRundt-SessionId'));
      var sessionRandomId;

  		if(savedData) {
  			if(savedData.timeStamp == dateObject) {
  				sessionRandomId = savedData.sessionId;
  			}
  		}

  		var sessionData = JSON.stringify({sessionId: sessionRandomId, site: site, value: value, platform: 'web'});
  		//console.log(sessionData);
  		$.ajax({
  			type: "POST",
  			dataType: "json",
  			url: "https://apps.odenserundt.dk/apptools/orApi/",
  			data: {action: 'stat', data: sessionData},
  			async: false,
  			success: (data) => {
  				if(data.type == 'stat.session.begin') {
  					var object = JSON.stringify({sessionId: data.id, timeStamp: dateObject});
  					localStorage.setItem('OdenseRundt-SessionId', object);
  					//console.log(data.id);
  				}
  			},
  			error: function(data) {
  				console.log('error:');
  				console.log(data);
  			}
  		});
    }
  },

  generateMetaTags: function(title, description) {
    var titleElem = document.querySelector('[name=title]');
    var descriptionElem = document.querySelector('[name=description]');
    if(titleElem != null) {
      titleElem.setAttribute('content', title);
    }
    else {
      var titleMeta = document.createElement('meta');
      titleMeta.setAttribute('name', 'title');
      titleMeta.setAttribute('content', title);
      document.getElementsByTagName('head')[0].appendChild(titleMeta);
    }

    if(descriptionElem != null) {
      descriptionElem.setAttribute('content', description);
    }
    else {
      var descriptionMeta = document.createElement('meta');
      descriptionMeta.setAttribute('name', 'description');
      descriptionMeta.setAttribute('content', description);
      document.getElementsByTagName('head')[0].appendChild(descriptionMeta);
    }
  },

  scrollToTop: function() {
    window.scrollTo(0, 0);
  },

  setScreenReaderFocus: function(id) {
  	var focusElem;
  	if(id == undefined) {
  		if(DeviceCheck.isMobile) { focusElem = document.getElementById('mobile-page-title-text');	} else { focusElem = document.getElementById('content'); }
  	}
  	else {
  		focusElem = document.getElementById(id);
  	}
  	focusElem.setAttribute("tabindex", "-1");
  	//focusElem.style.outline = "none";
  	focusElem.focus();
  },
};
